import { MapType } from "@/features/map/presentation/pages/AgroMap";

export const baseConfigs = {
  googleHybridUrl: "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
  attribution: "google | agroyaar",
  zoom: 14,
  maxZoom: 20,
  subdomains: ["mt0", "mt1", "mt2", "mt3"],
  mapCenter: [35.5868, 59.35469],
};

export function zoomControlConfig(type: MapType) {
  return (
    type === "drawPolygonWithConfirm" ||
    type === "drawPolygonWithoutConfirm" ||
    type === "addMarker"
  );
}

export const persianTranslation = {
  tooltips: {
    placeMarker: "کلیک برای جانمایی نشان",
    firstVertex: "اولین نقطه را رسم کنید",
    continueLine: "نقطه بعدی را رسم کنید",
    finishLine: "جهت پایان روی آخرین نقطه موجود مجددا کلیک کنید",
    finishPoly: "با کلیک روی نقطه اول، محدوده رسم خواهد شد",
    finishRect: "کلیک برای پایان",
    startCircle: "کلیک برای رسم مرکز دایره",
    finishCircle: "کلیک برای پایان رسم دایره",
    placeCircleMarker: "کلیک برای رسم نشان دایره",
    placeText: "کلیک برای نوشتن متن",
  },
  actions: {
    finish: "تایید",
    cancel: "لفو",
    removeLastVertex: "حذف آخرین نقطه",
  },
  buttonTitles: {
    drawMarkerButton: "درج نشان",
    drawPolyButton: "رسم چندضلعی",
    drawLineButton: "رسم خط",
    drawCircleButton: "رسم دایره",
    drawRectButton: "رسم چهارضلعی",
    editButton: "ویرایش لایه‌ها",
    dragButton: "جابجایی لایه‌ها",
    cutButton: "برش لایه‌ها",
    deleteButton: "حذف لایه‌ها",
    drawCircleMarkerButton: "رسم نشان دایره",
    snappingButton: "نشانگر را به لایه‌ها و رئوس دیگر بکشید",
    pinningButton: "رئوس مشترک را با هم پین کنید",
    rotateButton: "چرخش لایه",
    drawTextButton: "رسم متن",
  },
};

export const toolbarBaseControls = {
  position: "topright", // Position of the control toolbox on the map

  // Drawing Controls
  drawMarker: false, // Enable/Disable marker drawing
  drawCircleMarker: false, // Enable/Disable circle marker drawing
  drawText: false, // Enable/Disable text drawing
  drawPolyline: false, // Enable/Disable polyline drawing
  drawRectangle: false, // Enable/Disable rectangle drawing
  drawPolygon: false, // Enable/Disable polygon drawing
  drawCircle: false, // Enable/Disable circle drawing

  // Editing Controls
  editMode: false, // Enable/Disable edit mode (edit shapes)
  dragMode: false, // Enable/Disable drag mode (drag shapes)
  cutPolygon: false, // Enable/Disable cut mode (cut polygons)

  // Removal Controls
  removalMode: false, // Enable/Disable removal mode (delete shapes)

  // Interaction Controls
  rotateMode: false, // Enable/Disable rotate mode (rotate shapes)
  snapping: false, // Enable/Disable snapping (auto-align to other shapes)
  hintline: false, // Show hintline while drawing
  markerEditable: false, // Allow markers to be editable
  markerRemovable: false, // Allow markers to be removable

  // Misc Controls
  allowSelfIntersection: false, // Allow/Disallow self-intersecting polygons
  pathOptions: {}, // Custom path options for drawn shapes (e.g., color, weight)
  templineStyle: {}, // Custom style for the template line while drawing
  hintlineStyle: {}, // Custom style for the hint line while drawing
  finishOnDoubleClick: false, // Finish drawing on double-click
};

export const globalEditMode = {
  snappable: true,
  allowSelfIntersection: false,
  allowSelfIntersectionEdit: false,
  allowEditing: true,
};
